/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

var imageAddr = "https://raw.githubusercontent.com/ctbids/ctbids/4daeba66511fa3a2f0869ec9aba66fcc5fb1ffc8/31120037-5mb.jpeg";
var downloadSize = 4995374; //bytes

export const MeasureConnectionSpeed = () => {
    return new Promise((resolve, reject) => {
        var startTime, endTime;
        var download = new Image();
        download.onload = function () {
            endTime = (new Date()).getTime();
            showResults();
        }
        
        download.onerror = function (err, msg) {
            reject("Invalid image, or error downloading");
        }
        
        startTime = (new Date()).getTime();
        var cacheBuster = "?nnn=" + startTime;
        download.src = imageAddr + cacheBuster;
        
        function showResults() {
            var duration = (endTime - startTime) / 1000;
            var bitsLoaded = downloadSize * 8;
            var speedBps = parseFloat((bitsLoaded / duration).toFixed(2));
            var speedKbps = parseFloat((speedBps / 1024).toFixed(2));
            var speedMbps = parseInt((speedKbps / 1024).toFixed(2));
            resolve({ speedBps, speedKbps, speedMbps });
        }
    });

}